import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import ArrowBack from '@material-ui/icons/ArrowBack'

const styles = theme => ({
  container: {
    fontWeight: 500,
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
})

const BackButton = ({
  classes, className, label, onPress 
}) => (
  <div className={classNames(className, classes.container)} onClick={onPress}>
    {label || <ArrowBack color="primary" style={{ fontSize: 28 }} />}
  </div>
)

BackButton.propTypes = {
  label: PropTypes.string,
  onPress: PropTypes.func,
  classes: PropTypes.object,
  className: PropTypes.string,
}

export default withStyles(styles)(BackButton)



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/BackButton.js